import { render } from "./ExperimentDetails.vue?vue&type=template&id=cd5eca4c&scoped=true"
import script from "./ExperimentDetails.vue?vue&type=script&lang=js"
export * from "./ExperimentDetails.vue?vue&type=script&lang=js"

import "./ExperimentDetails.vue?vue&type=style&index=0&id=cd5eca4c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd5eca4c"]])

export default __exports__